import { Injectable, EventEmitter } from "@angular/core";
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";
import { API_DATE_FORMAT } from 'src/app/fpx-core/constant';

import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  CriteriaQuery,
  HttpProviderService,
  LoadForm,
} from "@fpx/core";
import { IHttpSuccessPayload, ILookupResponse } from "@fpx/core";
import { add } from "@amcharts/amcharts4/.internal/core/utils/Array";
import { map, Observable, of } from "rxjs";
import {
  Loantransactionfilter
} from "./loantransactionfilter.model";
import { environment } from "src/environments/environment";
import { CommonService } from "src/app/common.service";
import moment from "moment";
@Injectable({providedIn:'any'})
export class LoantransactionfilterService implements BaseFpxDataService<any> {
  constructor(
    private _httpProvider: HttpProviderService,
    private _commonService: CommonService
  ) {}
  create(payload: any): CreateFn<any> {
    throw new Error("Method not implemented.");
  }
  findByKey(payload: any): FindByKeyFn<any> {
    throw new Error("Method not implemented.");
  }

  createFilter(payload: any): Observable<any> {
    const httpRequest = new HttpRequest();
    httpRequest.setMethod("GET");
    httpRequest.setResource("/loanStatementProvider");
    httpRequest.setServerContext(environment.loansPublisher);
    httpRequest.addQueryParameter("accountNumber", payload.accountNumber);

    if (payload.transactionPeriod == "0") {
      httpRequest.addQueryParameter("fileType", payload.fileType);
      httpRequest.addQueryParameter("Count", 20);
      let today = new Date();
      let endDate = moment(today).format(API_DATE_FORMAT);
      let startDate = moment(today).subtract(6, 'months').format(API_DATE_FORMAT);
      httpRequest.addQueryParameter('fromDate', startDate);
      // httpRequest.addQueryParameter('toDate', endDate);
      httpRequest.addQueryParameter('toDate', this._commonService.serverDate);
    } else if (payload.transactionPeriod == "1") {
      httpRequest.addQueryParameter("fromDate", payload.fromDate);
      httpRequest.addQueryParameter("toDate",  this._commonService.getCurrentDateAsServerDate(payload.toDate))
      httpRequest.addQueryParameter("fileType", payload.fileType);
    } else {
      httpRequest.addQueryParameter("fromDate", payload.fromDate);
      httpRequest.addQueryParameter("toDate", this._commonService.getCurrentDateAsServerDate(payload.toDate));
      httpRequest.addQueryParameter("fileType", payload.fileType);
    }
    this._commonService.showSpinner();
    return this._httpProvider.invokeDownloadApi(httpRequest);
  }
  modify(payload: any): ModifyFn<any> {
    throw new Error("Method not implemented.");
  }
  loadForm?(payload: any): LoadForm<any> {
    throw new Error("Method not implemented.");
  }

  findAll(criteriaQuery: CriteriaQuery): FindAllFn<any> {
    criteriaQuery.addSortCriteria('paymentDate','desc','Date');
    return () => {
      let accountNumber = criteriaQuery.getQueryparam("accountNumber");
      const httpRequest = new HttpRequest();
      httpRequest.setMethod("POST");
      httpRequest.setResource("/casatransaction/query");
      httpRequest.addQueryParameter("accountNumber", accountNumber);
      httpRequest.setServerContext(environment.accountsPublisher);
      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(
          map(
            (res: IHttpSuccessPayload<any>) =>
              res.body?.casatransaction?.casatransactiondtls ?? null
          )
        );
    };
  }

  lookup(key: any): LookUpFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod("GET");
      httpRequest.setResource("/casatransactionfilter");
      httpRequest.setServerContext(environment.accountsPublisher);
      httpRequest.addQueryParameter("lookup", 1);
      const httpCriteria = new CriteriaQuery();
      httpCriteria.setPaginationCriteria("1", 10);
      httpRequest.setCriteriaQuery(httpCriteria);

      return this._httpProvider.invokeDownloadApi(httpRequest).pipe(
        map((res: IHttpSuccessPayload<ILookupResponse>) => {
          return res.body?.Data;
        })
      );
    };
  }

  // downloadAccountStatements(accountNumber: string,fileType:any,count:any): Observable<any> {
  //   const httpRequest = new HttpRequest();
  //   httpRequest.setResource("/casaaccount/statement");
  //   httpRequest.setMethod("GET");
  //   httpRequest.setServerContext(environment.accountsPublisher);
  //   httpRequest.addQueryParameter("accountNumber", accountNumber);
  //   httpRequest.addQueryParameter("fileType", fileType);
  //   httpRequest.addQueryParameter("count", count);
  //   this._commonService.showSpinner();
  //   return this._httpProvider.invokeDownloadApi(httpRequest);
  // }
}
